<div [ngClass]="name ? 'input-box1 active' : 'input-box1 disable'">
  <input *ngIf="isName" [(ngModel)]="name" id="input" />
  <input *ngIf="!isName" [(ngModel)]="username" id="input" />
  <img class="phone-image" src="assets/general/name.svg" />
</div>
<div *ngIf="hasError" class="input-error">{{ message }}</div>
